import { render, staticRenderFns } from "./NetworkError.vue?vue&type=template&id=5525a28e&scoped=true&lang=pug&"
import script from "./NetworkError.vue?vue&type=script&lang=js&"
export * from "./NetworkError.vue?vue&type=script&lang=js&"
import style0 from "./NetworkError.vue?vue&type=style&index=0&id=5525a28e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5525a28e",
  null
  
)

export default component.exports